import styled from 'styled-components';

export const EntirePopularFacilityBack = styled.div`
  margin-left: 5%;
  margin-right: 5%;
  padding: 25px 0;
  margin-top: 0;
`;

export const SemiPopularFacilityBack = styled.div`
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 20px;
`;

export const PlaceName = styled.p`
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  min-width: 80px;
  flex-shrink: 0;
`;

export const GaugeBack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  margin-top: -10px;
`;

export const GaugeNumbers = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  color: #666;
  font-weight: 500;
`;
